export let PatientDobChangeWarningMixin = superclass => class extends superclass
{
    constructor ()
    {
        super();
        this.dobModal = null;
        this.dob = null;
        this.dobValue = null;
    }

    connectedCallback ()
    {
        this.#init();
    }

    #init ()
    {
        this.addDobWarningModal();
        this.initEventListenders();
    }

    addDobWarningModal()
    {
        const dob = this.querySelector('input[name="DOB"]');
        const modalHtml = `
<div class="modal fade dob-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
                <h5 class="modal-title">Changing Date of Birth</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" class="fa fa-times"></span>
                </button>
        </div>
        <div class="modal-body">
            <p>
                If you change the patients date of birth, the date of birth will be changed for all cases related to this patient.
            </p>
            <p>
                Are you sure you want to do this?
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-info btn-yes">Yes</button>
            <button type="button" class="btn btn-primary btn-no">No</button>
        </div>
    </div>
</div>`;
        if (dob) {
            const template = document.createElement('template');
            template.innerHTML = modalHtml;
            const modalElem = template.content.cloneNode(true);
            document.body.appendChild(modalElem);
            this.dobModal = document.querySelector('.dob-modal');
            $(this.dobModal).modal({show: false});
            const dobInput = this.querySelector('input[name="DOB"]');
            $(this.dobModal).on('hidden.bs.modal', () => {
                if (this.dob) {
                    $(dobInput).datepicker('setDate', this.dob);
                    this.dob = null;
                }
            });
            const modalYesBtn = this.dobModal.querySelector('.btn-yes');
            const modalNoBtn = this.dobModal.querySelector('.btn-no');
            modalYesBtn.addEventListener('click', () => {
                $(this.dobModal).modal('hide');
                this.dob = null;
            });
            modalNoBtn.addEventListener('click', () => {
                const datePickerCalendar = document.body.querySelector('.ui-datepicker');
                $(this.dobModal).modal('hide');
                $(dobInput).datepicker('setDate', this.dob);
                this.dob = null;
            });
        }
    }

    initEventListenders()
    {
        const dob = this.querySelector('input[name="DOB"]');

        setTimeout(() => {
            const datePickerCalendar = document.body.querySelector('.ui-datepicker');
            if (datePickerCalendar) {
                const dbCalanderObserver = new MutationObserver((mutations) => {
                    let calledHandler = false;
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === 'style') {
                            const prevStyle = mutation.oldValue;
                            if (!prevStyle || calledHandler) {
                                return;
                            }
                            const style = mutation.target.getAttribute('style');
                            if (style.indexOf('display: none') === -1 && prevStyle.indexOf('display: none') !== -1) {
                                calledHandler = true;
                                this.onDobCalendarShow(dob)
                            } else if (style.indexOf('display: none') !== -1 && prevStyle.indexOf('display: none') === -1) {
                                calledHandler = true;
                                this.onDobCalendarHide(dob)
                            }
                        }
                    });

                });
                dbCalanderObserver.observe(datePickerCalendar, {
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: ['style']
                });
            }
        }, 500);
    }

    onDobCalendarShow(dobElem)
    {
        this.dob = $(dobElem).datepicker('getDate');
        console.log(this.dob);

    }

    onDobCalendarHide(dobElem)
    {
        const $datePickerCalendar = $(dobElem);
        const newDob = $datePickerCalendar.datepicker('getDate');
        if (newDob != null && this.dob != null && typeof newDob == "object" && typeof this.dob == "object" && newDob.toDateString() != this.dob.toDateString()) {
            $(this.dobModal).modal('show');
        }
    }


}